import { PHONE_COUNTRY_CODES } from '../config/phone-codes'

export function isSmsForbiddenByNumber(phoneNumber: string | null) {
  return phoneNumber?.startsWith(PHONE_COUNTRY_CODES.DE)
}

export function isSmsForbiddenByCountry(country: string) {
  return country === 'DE'
}
